import { WALLETINVOICES } from '../actionTypes';

export const fetchWalletInvoices = (payload) => ({
  type: WALLETINVOICES.FETCH,
  payload,
});
